exports = module.exports = require("../../../node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ant-empty-img-default-path-1[data-v-7183552c]{fill:#aeb8c2}.ant-empty-img-default-path-2[data-v-7183552c]{fill:url(#linearGradient-1)}.ant-empty-img-default-path-3[data-v-7183552c]{fill:#f5f5f7}.ant-empty-img-default-path-4[data-v-7183552c],.ant-empty-img-default-path-5[data-v-7183552c]{fill:#dce0e6}.ant-empty-img-default-g[data-v-7183552c]{fill:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader?minimize!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_lodash@4.18.1_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7183552c","scoped":true,"hasInlineConfig":false}!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_lodash@4.18.1_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Empty/VEmpty.vue
// module id = od1U
// module chunks = 45